/**
 * GENERATED — do not edit by hand.
 * Source: data/semantic-layer/ysite-compat/usb/LL0034-V07/data.json
 * Regenerate: bun run scripts/gen-matrix-fixture.mjs
 *
 * Real USB LL0034-V07 catheter-compatibility matrix (61 drugs,
 * 1049 cells). Used as the board's data source until the
 * live matrix source is wired.
 */
import type { CompatibilityBoardState } from '@frontend/components/ysite/types'

export const YSITE_MATRIX_FIXTURE: CompatibilityBoardState = {
  "institution": "usb",
  "source_doc": "USB/LL0034-V07",
  "source_version": "V07",
  "valid_from": "2021-09-09",
  "valid_until": "2024-09-09",
  "drugs": [
    {
      "id": "(all carriers)",
      "label": "(all carriers)",
      "sentinel": true
    },
    {
      "id": "(any other drug)",
      "label": "(any other drug)",
      "sentinel": true
    },
    {
      "id": "Actilyse (Alteplase)",
      "label": "Actilyse (Alteplase)",
      "atc": "B01AD02",
      "snomed": "387390003"
    },
    {
      "id": "Actrapid 1 E/ml",
      "label": "Actrapid 1 E/ml",
      "atc": "A10AB01",
      "snomed": "39487003"
    },
    {
      "id": "Adrenalin 120 µg/ml",
      "label": "Adrenalin 120 µg/ml",
      "atc": "C01CA24",
      "snomed": "387362001"
    },
    {
      "id": "Aggrastat (Tirofiban) 50 µg/ml",
      "label": "Aggrastat (Tirofiban) 50 µg/ml",
      "atc": "B01AC17",
      "snomed": "108972005"
    },
    {
      "id": "Argatra (Argatroban) 1 mg/ml",
      "label": "Argatra (Argatroban) 1 mg/ml",
      "atc": "B01AE03",
      "snomed": "395936005"
    },
    {
      "id": "Atracurium 10 mg/ml",
      "label": "Atracurium 10 mg/ml",
      "atc": "M03AC04",
      "snomed": "387144009"
    },
    {
      "id": "Brevibloc (Esmolol) 10 mg/ml",
      "label": "Brevibloc (Esmolol) 10 mg/ml",
      "atc": "C07AB09",
      "snomed": "387389007"
    },
    {
      "id": "Catapresan (Clonidin) 18.75 µg/ml",
      "label": "Catapresan (Clonidin) 18.75 µg/ml",
      "atc": "C02AC01",
      "snomed": "387394008"
    },
    {
      "id": "Cleviprex (Clevidipin)",
      "label": "Cleviprex (Clevidipin)",
      "atc": "C08CA16",
      "snomed": "713411006"
    },
    {
      "id": "Cordarone (Amiodaron) 18.75 mg/ml",
      "label": "Cordarone (Amiodaron) 18.75 mg/ml",
      "atc": "C01BD01",
      "snomed": "372805001"
    },
    {
      "id": "Dexdor (Dexmedetomidin-HCl) 4 µg/ml",
      "label": "Dexdor (Dexmedetomidin-HCl) 4 µg/ml",
      "atc": "N05CM18",
      "snomed": "412371008"
    },
    {
      "id": "Dobutrex (DOBUtamin) 5 mg/ml",
      "label": "Dobutrex (DOBUtamin) 5 mg/ml",
      "atc": "C01CA07",
      "snomed": "387145005"
    },
    {
      "id": "DOPAmin 5 mg/ml",
      "label": "DOPAmin 5 mg/ml",
      "atc": "C01CA04",
      "snomed": "387145006"
    },
    {
      "id": "Dormicum (Midazolam) 3 mg/ml",
      "label": "Dormicum (Midazolam) 3 mg/ml",
      "atc": "N05CD08",
      "snomed": "373476007"
    },
    {
      "id": "Esomep (Esomeprazol)",
      "label": "Esomep (Esomeprazol)",
      "atc": "A02BC05",
      "snomed": "395921007"
    },
    {
      "id": "Fentanyl 50 µg/ml",
      "label": "Fentanyl 50 µg/ml",
      "atc": "N01AH01",
      "snomed": "373492002"
    },
    {
      "id": "Flumazenil",
      "label": "Flumazenil",
      "atc": "V03AB25",
      "snomed": "372695004"
    },
    {
      "id": "Fragmin (Dalteparin)",
      "label": "Fragmin (Dalteparin)",
      "atc": "B01AB04",
      "snomed": "372563008"
    },
    {
      "id": "Fungizone (Amphotericine B)",
      "label": "Fungizone (Amphotericine B)",
      "atc": "J02AA01",
      "snomed": "387141001"
    },
    {
      "id": "Glucose 10%",
      "label": "Glucose 10%",
      "atc": "B05BA03",
      "snomed": "387341002"
    },
    {
      "id": "Glucose 20%",
      "label": "Glucose 20%",
      "atc": "B05BA03",
      "snomed": "387341002"
    },
    {
      "id": "Glucose 5%",
      "label": "Glucose 5%",
      "atc": "B05BA03",
      "snomed": "387341002"
    },
    {
      "id": "Glypressin (Terlipressin)",
      "label": "Glypressin (Terlipressin)",
      "atc": "H01BA04",
      "snomed": "387048002"
    },
    {
      "id": "Heparin Natrium 100 E/ml",
      "label": "Heparin Natrium 100 E/ml",
      "atc": "B01AB01",
      "snomed": "372877000"
    },
    {
      "id": "Heparin Natrium 200 E/ml",
      "label": "Heparin Natrium 200 E/ml",
      "atc": "B01AB01",
      "snomed": "372877000"
    },
    {
      "id": "Isuprel (Isoprenalin) 4 µg/ml",
      "label": "Isuprel (Isoprenalin) 4 µg/ml",
      "atc": "C01CA02",
      "snomed": "387373007"
    },
    {
      "id": "Kaliumchlorid 1 mmol/ml",
      "label": "Kaliumchlorid 1 mmol/ml",
      "atc": "B05XA01",
      "snomed": "387202004"
    },
    {
      "id": "Kaliumphosphat 1 mmol/ml",
      "label": "Kaliumphosphat 1 mmol/ml",
      "atc": "B05XA17",
      "snomed": "70335003"
    },
    {
      "id": "Ketamin 50 mg/ml",
      "label": "Ketamin 50 mg/ml",
      "atc": "N01AX03",
      "snomed": "387286002"
    },
    {
      "id": "Lasix (Furosemid) 10 mg/ml",
      "label": "Lasix (Furosemid) 10 mg/ml",
      "atc": "C03CA01",
      "snomed": "387475002"
    },
    {
      "id": "Magnesium sulfat 0.8 mmol/ml",
      "label": "Magnesium sulfat 0.8 mmol/ml",
      "atc": "A12CC02",
      "snomed": "387202005"
    },
    {
      "id": "Meropenem 40 mg/ml",
      "label": "Meropenem 40 mg/ml",
      "atc": "J01DH02",
      "snomed": "387184005"
    },
    {
      "id": "Milrinon 200 µg/ml",
      "label": "Milrinon 200 µg/ml",
      "atc": "C01CE02",
      "snomed": "372577000"
    },
    {
      "id": "Morphin HCl 1 mg/ml",
      "label": "Morphin HCl 1 mg/ml",
      "atc": "N02AA01",
      "snomed": "373529000"
    },
    {
      "id": "NaCl 0.9%",
      "label": "NaCl 0.9%",
      "atc": "B05XA03",
      "snomed": "387390004"
    },
    {
      "id": "NaCl 3%",
      "label": "NaCl 3%",
      "atc": "B05XA03",
      "snomed": "387390004"
    },
    {
      "id": "Naloxon 40 µg/ml",
      "label": "Naloxon 40 µg/ml",
      "atc": "V03AB15",
      "snomed": "387317005"
    },
    {
      "id": "Natrium Bicarbonat 1 mmol/ml",
      "label": "Natrium Bicarbonat 1 mmol/ml",
      "atc": "B05XA02",
      "snomed": "387328002"
    },
    {
      "id": "Natriumbenzoat",
      "label": "Natriumbenzoat",
      "atc": "A16AX",
      "snomed": "387448004"
    },
    {
      "id": "Neostigmin 0.5 mg/ml",
      "label": "Neostigmin 0.5 mg/ml",
      "atc": "N07AA01",
      "snomed": "387323007"
    },
    {
      "id": "Nitroglycerin 50 µg/ml",
      "label": "Nitroglycerin 50 µg/ml",
      "atc": "C01DA02",
      "snomed": "387404004"
    },
    {
      "id": "Noradrenalin-Bitartrat 120 µg/ml",
      "label": "Noradrenalin-Bitartrat 120 µg/ml",
      "atc": "C01CA03",
      "snomed": "45555007"
    },
    {
      "id": "Novorapid 1 E/ml",
      "label": "Novorapid 1 E/ml",
      "atc": "A10AB05",
      "snomed": "414515005"
    },
    {
      "id": "Orfiril (Natriumvalproat)",
      "label": "Orfiril (Natriumvalproat)",
      "atc": "N03AG01",
      "snomed": "387080000"
    },
    {
      "id": "Palladon 0.4 mg/ml",
      "label": "Palladon 0.4 mg/ml",
      "atc": "N02AA03",
      "snomed": "373492003"
    },
    {
      "id": "Pantozol (Pantoprazol) 2 mg/ml",
      "label": "Pantozol (Pantoprazol) 2 mg/ml",
      "atc": "A02BC02",
      "snomed": "395977003"
    },
    {
      "id": "Phenhydan (Phenytoin-Natrium)",
      "label": "Phenhydan (Phenytoin-Natrium)",
      "atc": "N03AB02",
      "snomed": "373327004"
    },
    {
      "id": "Phenylephrin 100 µg/ml",
      "label": "Phenylephrin 100 µg/ml",
      "atc": "C01CA06",
      "snomed": "372685008"
    },
    {
      "id": "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml",
      "label": "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml",
      "atc": "J01CR05",
      "snomed": "385542004"
    },
    {
      "id": "Privigen (Immunoglobuline)",
      "label": "Privigen (Immunoglobuline)",
      "atc": "J06BA02",
      "snomed": "395921008"
    },
    {
      "id": "Propofol 1% 10 mg/ml",
      "label": "Propofol 1% 10 mg/ml",
      "atc": "N01AX10",
      "snomed": "387423006"
    },
    {
      "id": "Remifentanil 50 µg/ml",
      "label": "Remifentanil 50 µg/ml",
      "atc": "N01AH06",
      "snomed": "404821007"
    },
    {
      "id": "Ringeracetat",
      "label": "Ringeracetat",
      "atc": "B05BB01",
      "snomed": "418938005"
    },
    {
      "id": "Ringerlactat",
      "label": "Ringerlactat",
      "atc": "B05BB01",
      "snomed": "385941002"
    },
    {
      "id": "Sandostatin (Octreotid) 8.3 µg/ml",
      "label": "Sandostatin (Octreotid) 8.3 µg/ml",
      "atc": "H01CB02",
      "snomed": "387028003"
    },
    {
      "id": "Simdax (Levosimendan)",
      "label": "Simdax (Levosimendan)",
      "atc": "C01CX08",
      "snomed": "412563000"
    },
    {
      "id": "Thiopental 25 mg/ml",
      "label": "Thiopental 25 mg/ml",
      "atc": "N01AF03",
      "snomed": "373288007"
    },
    {
      "id": "Trandate (Labetalol) 5 mg/ml",
      "label": "Trandate (Labetalol) 5 mg/ml",
      "atc": "C07AG01",
      "snomed": "387394009"
    },
    {
      "id": "Urapidil",
      "label": "Urapidil",
      "atc": "C02CA06",
      "snomed": "387476001"
    }
  ],
  "cells": {
    "Aggrastat (Tirofiban) 50 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Atracurium 10 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Glucose 10%": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Glucose 20%": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Aggrastat (Tirofiban) 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Brevibloc (Esmolol) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Aggrastat (Tirofiban) 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Argatra (Argatroban) 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Aggrastat (Tirofiban) 50 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Fragmin (Dalteparin)|Glucose 10%": {
      "verdict": "no_data"
    },
    "Fragmin (Dalteparin)|Glucose 20%": {
      "verdict": "no_data"
    },
    "Fragmin (Dalteparin)|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Fragmin (Dalteparin)|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "(any other drug)|Fragmin (Dalteparin)": {
      "verdict": "requires_line_flush"
    },
    "Milrinon 200 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Milrinon 200 µg/ml": {
      "verdict": "no_data"
    },
    "Milrinon 200 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Milrinon 200 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Milrinon 200 µg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Milrinon 200 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "incompatible"
    },
    "Milrinon 200 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "no_data"
    },
    "Milrinon 200 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Milrinon 200 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Milrinon 200 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Milrinon 200 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Milrinon 200 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Phenylephrin 100 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Dormicum (Midazolam) 3 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Palladon 0.4 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Phenylephrin 100 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Phenylephrin 100 µg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Phenylephrin 100 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Glucose 10%|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Phenylephrin 100 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Nitroglycerin 50 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Phenylephrin 100 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Phenylephrin 100 µg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Phenylephrin 100 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Phenylephrin 100 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Phenylephrin 100 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Phenylephrin 100 µg/ml": {
      "verdict": "no_data"
    },
    "Flumazenil|Glucose 10%": {
      "verdict": "no_data"
    },
    "Flumazenil|Glucose 20%": {
      "verdict": "no_data"
    },
    "Flumazenil|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Flumazenil|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "(any other drug)|Flumazenil": {
      "verdict": "requires_line_flush"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|NaCl 0.9%": {
      "verdict": "incompatible"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Ringeracetat": {
      "verdict": "incompatible"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cordarone (Amiodaron) 18.75 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "(all carriers)|Cordarone (Amiodaron) 18.75 mg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "Heparin Natrium 100 E/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Thiopental 25 mg/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "incompatible"
    },
    "Heparin Natrium 100 E/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Ketamin 50 mg/ml": {
      "verdict": "incompatible"
    },
    "Heparin Natrium 200 E/ml|Ketamin 50 mg/ml": {
      "verdict": "incompatible"
    },
    "Heparin Natrium 100 E/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Heparin Natrium 100 E/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Heparin Natrium 200 E/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Heparin Natrium 100 E/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Heparin Natrium 100 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Heparin Natrium 200 E/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Heparin Natrium 100 E/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 200 E/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Heparin Natrium 100 E/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Heparin Natrium 200 E/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Fentanyl 50 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Palladon 0.4 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Morphin HCl 1 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Ringerlactat|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Sandostatin (Octreotid) 8.3 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Meropenem 40 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Magnesium sulfat 0.8 mmol/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Ketamin 50 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Naloxon 40 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Neostigmin 0.5 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 20%|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 5%|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "NaCl 0.9%|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Thiopental 25 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Nitroglycerin 50 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "no_data"
    },
    "Propofol 1% 10 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Remifentanil 50 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Ringeracetat|Thiopental 25 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Thiopental 25 mg/ml": {
      "verdict": "incompatible"
    },
    "(all carriers)|Thiopental 25 mg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "Glucose 10%|Phenhydan (Phenytoin-Natrium)": {
      "verdict": "incompatible"
    },
    "Glucose 20%|Phenhydan (Phenytoin-Natrium)": {
      "verdict": "incompatible"
    },
    "Glucose 5%|Phenhydan (Phenytoin-Natrium)": {
      "verdict": "incompatible"
    },
    "NaCl 0.9%|Phenhydan (Phenytoin-Natrium)": {
      "verdict": "incompatible"
    },
    "(any other drug)|Phenhydan (Phenytoin-Natrium)": {
      "verdict": "requires_line_flush"
    },
    "Dormicum (Midazolam) 3 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "Dormicum (Midazolam) 3 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Dormicum (Midazolam) 3 mg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Dormicum (Midazolam) 3 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Dormicum (Midazolam) 3 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Dormicum (Midazolam) 3 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Dormicum (Midazolam) 3 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dormicum (Midazolam) 3 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Fentanyl 50 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Fentanyl 50 µg/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Fentanyl 50 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Fentanyl 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Fentanyl 50 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Palladon 0.4 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Palladon 0.4 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Palladon 0.4 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Neostigmin 0.5 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Palladon 0.4 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 20%|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Palladon 0.4 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Palladon 0.4 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Palladon 0.4 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Palladon 0.4 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Palladon 0.4 mg/ml": {
      "verdict": "no_data"
    },
    "Palladon 0.4 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Palladon 0.4 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Lasix (Furosemid) 10 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Morphin HCl 1 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Morphin HCl 1 mg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Morphin HCl 1 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Morphin HCl 1 mg/ml": {
      "verdict": "no_data"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Ringerlactat": {
      "verdict": "incompatible"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Neostigmin 0.5 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 20%|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "NaCl 0.9%|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Nitroglycerin 50 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Actrapid 1 E/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "incompatible"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Novorapid 1 E/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Piperacillin-Tazobactam (EDTA frei) 90 mg/ml|Ringeracetat": {
      "verdict": "incompatible"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumphosphat 1 mmol/ml|Piperacillin-Tazobactam (EDTA frei) 90 mg/ml": {
      "verdict": "no_data"
    },
    "Ringerlactat|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Ringerlactat": {
      "verdict": "incompatible"
    },
    "Adrenalin 120 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Ringerlactat|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Propofol 1% 10 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Actrapid 1 E/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Remifentanil 50 µg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Ringerlactat": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Ringerlactat": {
      "verdict": "no_data"
    },
    "Kaliumphosphat 1 mmol/ml|Ringerlactat": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Neostigmin 0.5 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Glucose 10%|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Sandostatin (Octreotid) 8.3 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Propofol 1% 10 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "incompatible"
    },
    "Remifentanil 50 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "no_data"
    },
    "Novorapid 1 E/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ringeracetat|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Sandostatin (Octreotid) 8.3 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Glypressin (Terlipressin)": {
      "verdict": "incompatible"
    },
    "Glucose 20%|Glypressin (Terlipressin)": {
      "verdict": "incompatible"
    },
    "Glucose 5%|Glypressin (Terlipressin)": {
      "verdict": "incompatible"
    },
    "Glypressin (Terlipressin)|NaCl 0.9%": {
      "verdict": "no_data"
    },
    "(any other drug)|Glypressin (Terlipressin)": {
      "verdict": "requires_line_flush"
    },
    "Glucose 10%|Orfiril (Natriumvalproat)": {
      "verdict": "no_data"
    },
    "Glucose 20%|Orfiril (Natriumvalproat)": {
      "verdict": "no_data"
    },
    "Glucose 5%|Orfiril (Natriumvalproat)": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Orfiril (Natriumvalproat)": {
      "verdict": "compatible_same_lumen"
    },
    "(any other drug)|Orfiril (Natriumvalproat)": {
      "verdict": "requires_line_flush"
    },
    "Fungizone (Amphotericine B)|Glucose 10%": {
      "verdict": "no_data"
    },
    "Fungizone (Amphotericine B)|Glucose 20%": {
      "verdict": "no_data"
    },
    "Fungizone (Amphotericine B)|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Fungizone (Amphotericine B)|NaCl 0.9%": {
      "verdict": "incompatible"
    },
    "(any other drug)|Fungizone (Amphotericine B)": {
      "verdict": "requires_line_flush"
    },
    "Atracurium 10 mg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Glucose 10%": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Glucose 20%": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Atracurium 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Brevibloc (Esmolol) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Atracurium 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Atracurium 10 mg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Atracurium 10 mg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Novorapid 1 E/ml": {
      "verdict": "incompatible"
    },
    "Atracurium 10 mg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Atracurium 10 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "DOPAmin 5 mg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Dobutrex (DOBUtamin) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dobutrex (DOBUtamin) 5 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "DOPAmin 5 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "DOPAmin 5 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|DOPAmin 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|DOPAmin 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Novorapid 1 E/ml": {
      "verdict": "incompatible"
    },
    "DOPAmin 5 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "DOPAmin 5 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "DOPAmin 5 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "incompatible"
    },
    "Meropenem 40 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Meropenem 40 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Meropenem 40 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Meropenem 40 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Meropenem 40 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Meropenem 40 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Meropenem 40 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "no_data"
    },
    "Actrapid 1 E/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Kaliumchlorid 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Kaliumchlorid 1 mmol/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumchlorid 1 mmol/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Naloxon 40 µg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Lasix (Furosemid) 10 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Magnesium sulfat 0.8 mmol/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Magnesium sulfat 0.8 mmol/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Magnesium sulfat 0.8 mmol/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Magnesium sulfat 0.8 mmol/ml": {
      "verdict": "incompatible"
    },
    "Ketamin 50 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "incompatible"
    },
    "Ketamin 50 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Ketamin 50 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Ketamin 50 mg/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Ketamin 50 mg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Ketamin 50 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Ketamin 50 mg/ml": {
      "verdict": "incompatible"
    },
    "Naloxon 40 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Naloxon 40 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Naloxon 40 µg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Naloxon 40 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Naloxon 40 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Natrium Bicarbonat 1 mmol/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 10%|Neostigmin 0.5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Neostigmin 0.5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Neostigmin 0.5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "NaCl 0.9%|Neostigmin 0.5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Neostigmin 0.5 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "no_data"
    },
    "Kaliumphosphat 1 mmol/ml|Neostigmin 0.5 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 10%|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "incompatible"
    },
    "NaCl 0.9%|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Natrium Bicarbonat 1 mmol/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Natrium Bicarbonat 1 mmol/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Natrium Bicarbonat 1 mmol/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Natrium Bicarbonat 1 mmol/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Natrium Bicarbonat 1 mmol/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Natrium Bicarbonat 1 mmol/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Natrium Bicarbonat 1 mmol/ml|Ringeracetat": {
      "verdict": "incompatible"
    },
    "Natrium Bicarbonat 1 mmol/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Natrium Bicarbonat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Adrenalin 120 µg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Actilyse (Alteplase)|Glucose 10%": {
      "verdict": "incompatible"
    },
    "Actilyse (Alteplase)|Glucose 20%": {
      "verdict": "incompatible"
    },
    "Actilyse (Alteplase)|Glucose 5%": {
      "verdict": "incompatible"
    },
    "Glucose 10%|NaCl 3%": {
      "verdict": "no_data"
    },
    "Glucose 20%|NaCl 3%": {
      "verdict": "no_data"
    },
    "Glucose 5%|NaCl 3%": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Glucose 10%": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Glucose 20%": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Glucose 5%": {
      "verdict": "no_data"
    },
    "Glucose 10%|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 20%|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Natriumbenzoat": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Natriumbenzoat": {
      "verdict": "no_data"
    },
    "Glucose 5%|Natriumbenzoat": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 20%|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 5%|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Glucose 10%|Urapidil": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Urapidil": {
      "verdict": "no_data"
    },
    "Glucose 5%|Urapidil": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Glucose 10%": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Glucose 20%": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Esomep (Esomeprazol)|Glucose 10%": {
      "verdict": "no_data"
    },
    "Esomep (Esomeprazol)|Glucose 20%": {
      "verdict": "no_data"
    },
    "Esomep (Esomeprazol)|Glucose 5%": {
      "verdict": "no_data"
    },
    "Glucose 10%|Privigen (Immunoglobuline)": {
      "verdict": "no_data"
    },
    "Glucose 20%|Privigen (Immunoglobuline)": {
      "verdict": "no_data"
    },
    "Glucose 5%|Privigen (Immunoglobuline)": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Glucose 10%": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Glucose 20%": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 20%|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Glucose 20%|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Glucose 10%": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Glucose 20%": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Glucose 5%": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Simdax (Levosimendan)": {
      "verdict": "no_data"
    },
    "Glucose 20%|Simdax (Levosimendan)": {
      "verdict": "no_data"
    },
    "Glucose 5%|Simdax (Levosimendan)": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Glucose 5%|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 10%|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 20%|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Glucose 5%|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Cleviprex (Clevidipin)|Glucose 10%": {
      "verdict": "no_data"
    },
    "Cleviprex (Clevidipin)|Glucose 20%": {
      "verdict": "no_data"
    },
    "Cleviprex (Clevidipin)|Glucose 5%": {
      "verdict": "no_data"
    },
    "Adrenalin 120 µg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "incompatible"
    },
    "Adrenalin 120 µg/ml|Brevibloc (Esmolol) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Adrenalin 120 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Adrenalin 120 µg/ml": {
      "verdict": "incompatible"
    },
    "Adrenalin 120 µg/ml|Argatra (Argatroban) 1 mg/ml": {
      "verdict": "no_data"
    },
    "Adrenalin 120 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Adrenalin 120 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Adrenalin 120 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Adrenalin 120 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Isuprel (Isoprenalin) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Isuprel (Isoprenalin) 4 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Brevibloc (Esmolol) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Brevibloc (Esmolol) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Brevibloc (Esmolol) 10 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actilyse (Alteplase)|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "(any other drug)|Actilyse (Alteplase)": {
      "verdict": "requires_line_flush"
    },
    "NaCl 0.9%|NaCl 3%": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "NaCl 0.9%|Natriumbenzoat": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Urapidil": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Esomep (Esomeprazol)|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Privigen (Immunoglobuline)": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Simdax (Levosimendan)": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "NaCl 0.9%|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|NaCl 0.9%": {
      "verdict": "compatible_same_lumen"
    },
    "Cleviprex (Clevidipin)|NaCl 0.9%": {
      "verdict": "no_data"
    },
    "(any other drug)|NaCl 3%": {
      "verdict": "requires_line_flush"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "no_data"
    },
    "Actrapid 1 E/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Catapresan (Clonidin) 18.75 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "(all carriers)|Catapresan (Clonidin) 18.75 µg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "Nitroglycerin 50 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Propofol 1% 10 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Argatra (Argatroban) 1 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "incompatible"
    },
    "Remifentanil 50 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Novorapid 1 E/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Ringeracetat|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Trandate (Labetalol) 5 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Nitroglycerin 50 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Novorapid 1 E/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Nitroglycerin 50 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Nitroglycerin 50 µg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "incompatible"
    },
    "Propofol 1% 10 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Propofol 1% 10 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Propofol 1% 10 mg/ml": {
      "verdict": "no_data"
    },
    "(all carriers)|Propofol 1% 10 mg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "(any other drug)|Natriumbenzoat": {
      "verdict": "requires_line_flush"
    },
    "Actrapid 1 E/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Lasix (Furosemid) 10 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "incompatible"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Lasix (Furosemid) 10 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "incompatible"
    },
    "(all carriers)|Lasix (Furosemid) 10 mg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "(any other drug)|Urapidil": {
      "verdict": "requires_line_flush"
    },
    "Actrapid 1 E/ml|Argatra (Argatroban) 1 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Actrapid 1 E/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "incompatible"
    },
    "Actrapid 1 E/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "compatible_same_lumen"
    },
    "(any other drug)|Esomep (Esomeprazol)": {
      "verdict": "requires_line_flush"
    },
    "(any other drug)|Privigen (Immunoglobuline)": {
      "verdict": "requires_line_flush"
    },
    "Argatra (Argatroban) 1 mg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Dexdor (Dexmedetomidin-HCl) 4 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Argatra (Argatroban) 1 mg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Argatra (Argatroban) 1 mg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Remifentanil 50 µg/ml": {
      "verdict": "incompatible"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Novorapid 1 E/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Pantozol (Pantoprazol) 2 mg/ml|Ringeracetat": {
      "verdict": "incompatible"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Pantozol (Pantoprazol) 2 mg/ml": {
      "verdict": "incompatible"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Novorapid 1 E/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Remifentanil 50 µg/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Kaliumphosphat 1 mmol/ml|Remifentanil 50 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_same_lumen"
    },
    "Dexdor (Dexmedetomidin-HCl) 4 µg/ml|Kaliumphosphat 1 mmol/ml": {
      "verdict": "no_data"
    },
    "(any other drug)|Simdax (Levosimendan)": {
      "verdict": "requires_line_flush"
    },
    "Novorapid 1 E/ml|Ringeracetat": {
      "verdict": "compatible_same_lumen"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Novorapid 1 E/ml": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Novorapid 1 E/ml": {
      "verdict": "no_data"
    },
    "Noradrenalin-Bitartrat 120 µg/ml|Ringeracetat": {
      "verdict": "no_data"
    },
    "Kaliumphosphat 1 mmol/ml|Ringeracetat": {
      "verdict": "incompatible"
    },
    "Kaliumphosphat 1 mmol/ml|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "no_data"
    },
    "(all carriers)|Noradrenalin-Bitartrat 120 µg/ml": {
      "verdict": "compatible_with_all_carriers"
    },
    "(any other drug)|Cleviprex (Clevidipin)": {
      "verdict": "requires_line_flush"
    }
  }
}
